import { render } from "./alertifram.vue?vue&type=template&id=5d3b80ca"
import script from "./alertifram.vue?vue&type=script&lang=js"
export * from "./alertifram.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__